import React from 'react';
import firebase from '../lib/Firebase';
import Loader from './ui/Loader';
import API from '../lib/API';
import PRAPI from '../lib/PRAPI';
import ProofreadCanvas from './ProofreadCanvas';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage, faArrowPointer, faHand, faSearchPlus, faSearchMinus, faSquarePlus,
  faCamera, faTimes, faUpload, faSave, faRotateLeft, faRotateRight, faGlasses, faDownload,
  faExpand, faArrowsLeftRight, faArrowRightLong, faCropSimple, faTrash, faA, faFilePdf} from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import ProofreadFile from '../lib/ProofreadFile';
import LoadingOverlay from 'react-loading-overlay';
import Utils from '../lib/Utils';
import CrossRectSVG from './ProofreadIcon/CrossRectSVG';
import config from '../config';
import ProofreadHist from '../lib/ProofreadHist';
import PDFDialog from './PDFDialog';

import './Proofread.css';

class Proofread extends React.Component {
  state = {
    loading: true,

    uuid: null, // ブラウザーUUID 排他オープン用

    albumCode:null,
    albumData:null,
    hinmei: null,

    selectedOriuq: -1,
    koseiStart: null, // PSAPI校正開始日
    prStatus: null,

    preview: null,
    previewFilename: null, 
    openedStatus: null, // 排他オープンステータス（opened, closed）
    selectedTool: "default",

    changeStarted: null, // 入替ツールメッセージ
    moveStarted:null, // 移動ツールメッセージ
    showUploadDialog:false,// 写真一覧ダイアログ

    loadingUploadDialog: true, 
    uploadedPhotos:[],  // 写真一覧
    selectedPhotos:[],

    loadingOverlay: false,
    showSaveDialog: false, // 保存ダイアログ
    showSaveAlert: false, // 折切り替えの際に保存されていなかった場合に表示するダイアログ OK押下時のコールバック

    histories: null,

    showCustomerFinish: false,
    showToSchool:false,
    showSchoolFinish:false,
    showLogout: false,
    showAlert: null,

    canvasWidth: null,
    canvasHeight:null,

    hasPrev: false,
    hasNext: false,

    selectedTarget: null,
  }
  openedTimer = null;
  manualPdfCache = null;

  startCheckOpenedTimer = () => {
    clearInterval(this.openedTimer);
    this.openedTimer = setInterval(()=>{
      if ( ['start', 'retake', 'finish', 'noChangeFinish'].indexOf(this.state.prStatus)<0 ) {
        PRAPI.open(this.state.uuid, this.state.selectedOriuq, this.state.koseiStart).then(ret=>{
          if (ret.opened && ['opened', 'reopen'].indexOf(this.state.openedStatus) < 0) {
            let ori = this.getOri(this.state.selectedOriuq);
            this.changeOri(ori);
          }
        });
      }
      else {
        PRAPI.checkStatus(this.state.uuid, this.state.selectedOriuq, this.state.koseiStart).then(ret=>{
          //console.log(ret)
        });
      }
    }, 10000);
  }
  stopCheckOpenedTimer = () => { clearInterval(this.openedTimer); }

  componentDidMount(){
    let target = this.props.location.pathname.replace(/\/proofread\/?/, '');
    
    let uuid = (()=> {
      let type = target.match(/^\S{32}$/) ? 'school' : 'customer';
      try {
        let uuid = localStorage.getItem('BrowserUUID');
        if (!uuid.match('_'+type+'$')) throw new Error();
        if (uuid) return uuid
      }
      catch (e) {}
      let uuid = Utils.getUUID() + '_' + type;
      localStorage.setItem('BrowserUUID', uuid);
      return uuid;
    })();
    this.setState({
      uuid:uuid,
      canvasWidth: window.innerWidth - (250 + 62),
      canvasHeight:  window.innerHeight - 50,// - 168,
    });

    if (target.match(/^\d{14}$/)) {
      // アルバムサポートから
      firebase.auth().onAuthStateChanged(user => {
        if (!user) {
          window.location.href = '/';
        }
        this.loadAlbum(target);
      });
    }
    else {
      window.location.href = '/';
    }


    // ブラウザのリサイズでfabricjsのサイズを調整する
    window.addEventListener('resize', e => {
      this.setState({
        canvasWidth: window.innerWidth - (250 + 62) - (this.state.showSideFloat ? 300 : 0),
        canvasHeight: window.innerHeight - 88, //168
      })
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if ( ['start', 'retake', 'finish', 'noChangeFinish'].indexOf(this.state.prStatus) >= 0 && ['default','draw'].indexOf(this.state.selectedTool) >= 0) {
      this.setState({selectedTool: 'pan'});
    }
  }

  loadAlbum = (oriuq) => {
    PRAPI.load(oriuq).then(albumData => {
      if (!albumData) {
        this.setState({
          loading: false,
          showAlert: {message:"このアルバムにアクセスする権限がありません。"}
        });
        return;
      }

      this.setState({
        loading: false,
        albumCode:albumData.code,
        albumData: albumData,
        hinmei: albumData.hinmei,
      });

      if (albumData.oris.length === 0) {
        this.setState({
          showAlert: {message:"確認できるページがありません。"}
        });
      }
      
      let oriId = parseInt(oriuq.slice(-5),10);
      let ori = null;
      if (oriId) {
        ori = albumData.oris.find(o=>{
          return o.oriuq === oriuq;
        });
      }

      if (!ori) {
        this.setState({
          showAlert: {message:"確認できるページがありません。"}
        });
      }
      this.changeOri(ori);
    });
  }

  isNeedSave = () => {
    // 保存済みかチェック
    let currentData = this.PRCanvas.createSaveData();
    let prObjs = currentData.objects.filter(o=>{return o.type !== 'PRBase'; });
    if (this.state.savedFabricData) { // データを比較するためにsavedTimestamp, saveFromを合わせる
      currentData.savedTimestamp = this.state.savedFabricData.savedTimestamp;
      currentData.saveFrom = this.state.savedFabricData.saveFrom;
    }
    return ((!this.state.savedFabricData && prObjs.length > 0) || (this.state.savedFabricData && JSON.stringify(this.state.savedFabricData) !== JSON.stringify(currentData)));
  }
  getOri = oriuq => {
    return this.state.albumData.oris.find(o=>{return o.oriuq === oriuq});
  }
  changeOri = (ori) => {
    this.PRCanvas.clear();
    if (!ori) return;
    if (this.state.selectedOriuq > 0) {
      this.stopCheckOpenedTimer();
      PRAPI.close(this.state.uuid, this.state.selectedOriuq).then((ret)=>{
        //console.log('finish:', ret)
      });
    }
    let koseiStart = ori.kosei[ori.kosei.length-1].start;
    ProofreadFile.setOriuq(ori.oriuq);
    this.setState({
      savedFabricData: null,
      preview: null,
      previewFilename: null,
      openedStatus: null,
      showAlert: null,
      histories: null,
    });
    this.closeSideFloat();

    let doOpen = (['start','retake','finish','noChangeFinish'].indexOf(this.state.prStatus)<0);
    if (['finish', 'noChangeFinish'].indexOf(ori.prStatus.status)<0 || !ori.to_ctp) {
      ProofreadFile.load(this.state.uuid, koseiStart, doOpen).then(ret=>{
        if (this.state.selectedOriuq !== ori.oriuq) return;
        this.setState({
          savedFabricData: ret.savedFabricData,
          preview: ret.preview,
          previewFilename: ret.previewFilename,
          openedStatus: doOpen ? ret.openedStatus : 'opened'
        });
        this.startCheckOpenedTimer();
      }, err=>{
        //console.log(err)
        this.setState({
          showAlert: {message:"プレビュー画像を取得できませんでした。", closeButton:true}
        });
      });
    }
    ProofreadFile.setOriuq(ori.oriuq);
    ProofreadFile.loadPhotos();
    this.setState({
      selectedOriuq: ori.oriuq,
      koseiStart: koseiStart,
      prStatus: ori.kosei[ori.kosei.length-1].olpr ? ori.prStatus.status : 'finish'
    });
    ProofreadFile.listHistories().then(ret=>{
      // 最終保存の特定
      let newest = ret.reduce((t,h)=>{
        if (h.type === 'save' && t < h.timestamp) t = h.timestamp;
        return t;
      }, '');
      let histories = ret.map(h=>{
        if (h.type === 'save' && h.timestamp === newest) h.current = true;
        return h;
      });
      // 校了
      let isFinished = false;
      histories = histories.reduce((carry,h)=>{
        if (h.type === 'finish' || h.type === 'noChangeFinish') {
          isFinished = true;
          //if (!ori.to_ctp) return carry;
        }
        h.disabled = isFinished;
        carry.push(h);
        return carry;
      }, []);

      this.setState({
        histories: histories
      });

      if (!this.state.openedStatus && ori.to_ctp) {
        let finish = histories.find(h=>['finish','noChangeFinish'].indexOf(h.type)>=0);
        if (finish) {
          this.openOldDirection(finish.type, finish.filename);
          this.setState({history:finish.filename});
        }
      }
    });
  }
  openOldDirection = (type, directionFilename) => {
    this.PRCanvas.clear();
    this.setState({
      savedFabricData: null,
      preview: null,
      previewFilename: null,
      showAlert: null,
      openedStatus: 'reopen',
      prStatus: 'old',
    });

    let currentOriuq = this.state.selectedOriuq;
    if (['retake', 'finish','noChangeFinish'].indexOf(type) >= 0) {
      ProofreadFile.getDirectionPreview(directionFilename).then(blob=>{
        if (this.state.selectedOriuq !== currentOriuq) return;
        this.setState({
          preview: blob,
          previewFilename: directionFilename,
          openedStatus: 'opened',
        });
      });
    }
    else {
      ProofreadFile.loadOldDirection(directionFilename).then(ret=>{
        if (this.state.selectedOriuq !== currentOriuq) return;
        this.setState({
          savedFabricData: ret.savedFabricData,
          preview: ret.preview,
          previewFilename: ret.previewFilename,
          openedStatus: 'opened',
        });
      }, err=>{
        //console.log(err)
        this.setState({
          showAlert: {message:"データの取得に失敗しました。", closeButton:true}
        });
      });
    }
  }

  onClickTools = e => {
    e.preventDefault();
    if (this.state.openedStatus !== 'opened') return;
    if (!e.target.dataset.hasOwnProperty('toolName')) return;
    switch (e.target.dataset.toolName) {
      case 'undo':
        this.PRCanvas.undo();
        this.setState({
          hasPrev: ProofreadHist.hasPrev(),
          hasNext: ProofreadHist.hasNext(),
        });
        break;
      case 'redo':
        this.PRCanvas.redo();
        this.setState({
          hasPrev: ProofreadHist.hasPrev(),
          hasNext: ProofreadHist.hasNext(),
        });
        break;
      case 'allView':
        this.PRCanvas.setZoomToFitAll();
        break;
      case 'zoomPlus':
        this.PRCanvas.zoomToCenter(true);
       break;
      case 'zoomMinus':
        this.PRCanvas.zoomToCenter(false);
        break;
      case 'upload':
        let usedPhotos = this.state.savedFabricData ? this.state.savedFabricData.objects.filter(o=>o.directionType && o.directionType.match(/Photo$/) && o.photo).map(o=>o.photo) : [];
        usedPhotos = usedPhotos.concat(this.PRCanvas.createSaveData().objects.filter(o=>o.directionType && o.directionType.match(/Photo$/) && o.photo && usedPhotos.indexOf(o.photo) < 0).map(o=>o.photo));
        let nextSelectedPhotos = this.state.selectedPhotos.filter(u=>usedPhotos.indexOf(u)<0);

        this.setState({
          selectedPhotos: nextSelectedPhotos,
          showUploadDialog:true
        });
        this.loadUplaodedPhotos();
        break;
        /*
      case 'remove':
        this.PRCanvas.removeSelectedDirection();
        break;
        */
      case 'directionView':
        this.PRCanvas.toggleDirectionView();
        break;
      case 'downloadPreview':
        let filename = (() => {
          let ori = this.state.albumData.oris.find(o=>{
            return o.oriuq === this.state.selectedOriuq;
          });
          if (!ori) return 'OL校正-'+this.state.albumData.hinmei+'.jpg';
          return 'OL校正-'+this.state.albumData.hinmei+'P'+ori.pageName+'.jpg';
        })();
        let blob = this.PRCanvas.createPreview();
        let a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
        break;
      case 'showManual':
        if (!this.manualPdfCache) {
          API.getPublicFile('オンライン校正2509_02.pdf')
          .then(blob=>{
            this.manualPdfCache = blob;
            this.pdfDlg.open(blob, {title:'操作マニュアル', size:{height:'calc(100vh - 30px)', width:'calc(100vw - 30px)'}});
          })
        }
        else {
          this.pdfDlg.open(this.manualPdfCache, {title:'操作マニュアル', size:{height:'calc(100vh - 30px)', width:'calc(100vw - 30px)'}});
        }
        break;
      /*
      case 'save':
        this.setState({showSaveDialog:true});
        break;
        */
      default:
        this.setState({ selectedTool: e.target.dataset.toolName });
    }
  }

  onClickSaveButton = () => {
    this.setState({showSaveDialog:true});
  }

  onClickFinishBtns = e => {
    e.preventDefault();
    let callback = (()=>{
      if (e.target.classList.contains('finishBtn')) {
        return () => { this.setState({ showCustomerFinish: true, }) }
      }
      else if (e.target.classList.contains('toSchoolBtn')) {
        return ()=> {this.setState({  showToSchool: true, }) }
      }
      return null;
    })();
    if (!callback) return;

    if (this.isNeedSave()) {
      this.setState({ showSaveAlert: callback });
    }
    else {
      callback();
    }
    
  }

  onEventFromCanvas = opt => {
    //console.log(opt)
    switch (opt.name) {
      /*
      case 'CreatePRRect':
        this.setState({selectedTool:'default'});
        break;
        */
      case 'ChangeStart':this.setState({　changeStarted: opt.target, selectedTool: 'draw-changePlace'　});break;
      case 'ChangeStop':　this.setState({　changeStarted: null　});　break;
      case 'MoveStart':　this.setState({　moveStarted: opt.target　});　break;
      case 'MoveStop':　this.setState({　moveStarted: null　});　break;
      case 'ClickCanvas': this.setState({ selectedDirection:null }); break;
      case 'UpdatePRRect':
        // 指示リストの更新
        this.forceUpdate();
        break;
      case 'Selected':
        this.changeSelectTarget(opt.targetTimestamp);
        break;
      default:
    }

    this.setState({
      hasPrev: ProofreadHist.hasPrev(),
      hasNext: ProofreadHist.hasNext(),
    });
  }
  changeSelectTarget = (targetTimestamp) => {
    this.setState({selectedTarget: targetTimestamp});
  }
  onClickChangeCancelBtn = () => { 
    this.setState({changeStarted: null});
    this.PRCanvas.cancelCreateTarget();
  }
  onClickMoveCancelBtn = () => {
    this.setState({moveStarted: null});
    this.PRCanvas.cancelCreateTarget();
  }

  onClickUploadDialogCloseBtn = () => { 
    this.setState({ loadingUploadDialog:'ロード中' });
    ProofreadFile.loadPhotos(true).then(photos=>{
      this.setState({
        loadingUploadDialog:false,
        showUploadDialog:false,
        uploadedPhotos:photos
      });
    })
  }
  onClickUploadDialogUploadBtn = () => {
    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg';
    fileInput.multiple = true;
    fileInput.addEventListener('change', e => {
      Promise.all(Array.prototype.map.call(fileInput.files, file => {
        return new Promise((resolve, reject) => {
          let fr = new FileReader();
          fr.onloadend = e => {
            let arr = (new Uint8Array(e.target.result)).subarray(0, 4);
            let header = '';
            for (let i = 0; i < arr.length; i++) {
              header += arr[i].toString(16);
            }
            let type = null;
            switch (header) {
              case 'ffd8ffe0': 
              case 'ffd8ffe1': 
              case 'ffd8ffe2': type = 'image/jpeg'; break;
              default:
            }
            if (type) resolve(file);
            else resolve(null);
          }
          fr.readAsArrayBuffer(file);
        })

      })).then(result=>{
        let files = result.filter(f=>f);
        if ((this.state.uploadedPhotos.length + files.length) > config.maxUploadPhotoCount) files = files.slice(0, config.maxUploadPhotoCount-this.state.uploadedPhotos.length);
        if (files.length <= 0) {
          this.setState({showAlert: {message:'アップロード点数の制限を超えています。これ以上アップロードできません。', closeButton:true}});
          return;
        }
        
        let filenames = files.map(f=>f.name);
        let conflictFileNames = this.state.uploadedPhotos.filter(p=>{
          return filenames.indexOf(p.name.replace(/_[^_/]+(\.[^.]+)$/, '$1')) >= 0;
        });
        if (conflictFileNames.length > 0) {
          this.setState({showAlert: {
            message:'すでにアップロード済の画像と同じファイル名の画像があります。アップロードしますか？', 
            closeButton:true, 
            closeButtonTitle: 'キャンセル',
            okButton:()=>{
              this.setState({
                showAlert:null,
                alertCloseButton:false,
                alertOKButton:null
              })
              this.doUploadPhoto(files);
            },
            okButtonTitle:'アップロード'
          }});
        }
        else {
          this.doUploadPhoto(files);
        }
      })
    })
    fileInput.click();
  }
  doUploadPhoto = files => {
    this.setState({ loadingUploadDialog:'アップロード中' });
    Promise.all(files.map(f=>{
      return ProofreadFile.uploadPhoto(f);
    })).then((photos)=>{
      let newState = {
        uploadedPhotos: this.state.uploadedPhotos.slice(0,config.maxUploadPhotoCount),
        loadingUploadDialog:false
      }
      if ((this.state.uploadedPhotos.length + files.length) > config.maxUploadPhotoCount) {
        newState.showAlert = {message:'アップロード点数の制限を超えた分はアップロードされませんでした。', closeButton: true};
      }

      this.setState(newState);
    });
  }
  onClickUploadDialogDeleteBtn = () => {
    this.setState({ loadingUploadDialog:'削除中' })
    ProofreadFile.deletePhotos(this.state.selectedPhotos)
      .then((photos)=>{
        this.setState({
          uploadedPhotos: photos,
          loadingUploadDialog:false
        });
      })
  }
  onClickUploadDialogPhotos = e => {
    if (e.target.classList.contains('Proofread-Editor-UploadDialog-Photo')) {
      if (!e.target.classList.contains('selected')) {
        this.state.selectedPhotos.push(e.target.dataset.unique)
        this.setState({selectedPhotos: this.state.selectedPhotos});
      }
      else {
        this.setState({selectedPhotos: this.state.selectedPhotos.filter(u => u !== e.target.dataset.unique)});
      }
    }
    else {
      this.setState({selectedPhotos: []});
    }
  }

  loadUplaodedPhotos = () => {
    this.setState({ uploadedPhotos:[], loadingUploadDialog:'ロード中' });
    ProofreadFile.loadPhotos().then(photos => {
      this.setState({
        uploadedPhotos: photos,
        loadingUploadDialog:false
      });
    });
  }

  onClickSaveDialogButtons = e => {
    if (e.target.name === 'okBtn') {
      this.setState({loadingOverlay:true});
      this.save();
    }
    this.setState({showSaveDialog:false});
  }
  onClickSaveAlertButtons = e => {
    if (e.target.name === 'okBtn') {
      this.state.showSaveAlert();
    }
    this.setState({showSaveAlert:false});
  }

  onClickCustomerFinishAlertButtons = e => {
    e.preventDefault();
    if (e.target.name === 'okBtn') {
      let finishType = this.customerFinishType.customerFinish.value;//finish or retake
      let receiveMail = this.customerFinishType.receiveMail.checked;
      PRAPI.customerFinish(this.state.selectedOriuq, this.state.koseiStart, finishType, receiveMail).then(status=>{
        let albumData = this.state.albumData;
        albumData.oris = albumData.oris.map(o=>{
          if (o.oriuq === this.state.selectedOriuq) o.prStatus = status;
          return o;
        });
        this.setState ({prStatus: status.status, albumData:albumData});
      });
    }
    this.setState({showCustomerFinish:false});
  }
  onClickSchoolFinishAlertButtons = e => {
    e.preventDefault();
    if (e.target.name === 'okBtn') {
      PRAPI.schoolFinish(this.state.selectedOriuq, this.state.koseiStart).then(status=>{
        let albumData = this.state.albumData;
        albumData.oris = albumData.oris.filter(o=>{
          return !(o.oriuq === this.state.selectedOriuq && o.prStatus !== 'start');
        });
        this.setState ({prStatus: status.status, albumData:albumData});
        this.changeOri(albumData.oris[0]);
      });
    }
    this.setState({showSchoolFinish:false});
  }
  onClickToSchoolAlertButtons = e => {
    if (e.target.name === 'okBtn') {
      PRAPI.toSchool(this.state.selectedOriuq, this.state.koseiStart).then(status=>{
        let albumData = this.state.albumData;
        albumData.oris = albumData.oris.map(o=>{
          if (o.oriuq === this.state.selectedOriuq) o.prStatus = status;
          return o;
        });
        this.setState ({prStatus: status.status, albumData:albumData});
      });
    }
    this.setState({showToSchool:false});
  }

  onClickLogout = () => { this.setState({showLogout:true}); }
  onClickLogoutAlertButtons = e => {
    if (e.target.name === 'okBtn') {
      PRAPI.logout().then(ret=>{
        window.location.reload();
      });
    }
    this.setState({showLogout:false});
  }

  save = () => {
    let fabricData = this.PRCanvas.createSaveData();
    if (!fabricData) return;
    let preview = this.PRCanvas.createPreview();
    PRAPI.saveDirection(this.state.selectedOriuq, fabricData, preview).then(ret=>{
      this.setState({
        loadingOverlay:false,
        savedFabricData: ret,
      });
    });
  }

  directionTypeNames = {
    text: 'コメント',
    change: '場所入替',
    move: '場所移動',
    changePhoto: '写真差替',
    addPhoto: '写真追加',
    triming: 'トリミング',
    delete: 'トル',
    keep: '修正ナシ',
    changeChar: '文字変更',
  }
  getDirectionTypeName = directionType => {
    if (Object.keys(this.directionTypeNames).indexOf(directionType) < 0) return directionType;
    return this.directionTypeNames[directionType];
  }
  onClickDirections = e => {
    let directTimestamp = null;
    let direct = e.target.classList.contains('.Proofread-Direction') ? e.nativeEvent.target : e.target.closest('.Proofread-Direction');
    if (direct) {
      directTimestamp = this.state.selectedDirection === direct.dataset.timestamp ? null : direct.dataset.timestamp;
    }
    this.setState({selectedDirection: directTimestamp});
    this.PRCanvas.selectDirection(directTimestamp);
  }
  onClickHistories = e => {
    //if (e.target.classList.contains('.Proofread-Histories-items')) return;
    let target = e.target.classList.contains('.Proofread-History') ? e.target : e.target.closest('.Proofread-History');
    if (!target || !target.dataset.direction) return;

    if (target.dataset.current === 'true') this.changeOri( this.getOri(this.state.selectedOriuq));
    else this.openOldDirection(target.dataset.type, target.dataset.direction);
    this.setState({
      history: target.dataset.direction
    });
  }
  closeSideFloat = () => {
    this.setState({ 
      showSideFloat:false,
      selectedDirection:null,
      canvasWidth: window.innerWidth - (250 + 62)
    });
    this.PRCanvas.selectDirection(null);
  }

  onClickDirectionInput = e => {
    //e.stopPropagation();
    if (e.target.classList.contains('Proofread-Direction-ValueInput')) return;
    let direct = e.target.closest('.Proofread-Direction');
    let directValue = e.target.closest('.Proofread-Direction-Value');

    this.setState({
      directionEditTarget: {
        ts: direct.dataset.timestamp,
        key: directValue.dataset.key,
        height: directValue.clientHeight,
      }
    });
    e.preventDefault();
  }
  onBlurDirectionInput = e => {
    let directionItem = e.target.closest('.Proofread-Direction');
    let directValue = e.target.closest('.Proofread-Direction-Value');
    let direction = {};
    direction[directValue.dataset.key] = e.target.value;
    this.PRCanvas.updateDirection(direction, directionItem.dataset.timestamp);
    this.setState({ directionEditTarget: null});
  }
  onKeyDownDirectionInput = e => {
    if (e.nativeEvent.key === 'Enter') {
      e.target.style.height = 'calc('+e.target.style.height + ' + 1.6em)';
    }
  }


  historyTypeNames = {
    save: '保存',
    start:'学校確認依頼',
    stop:'学校確認完了',
    retake:'再校正依頼',
    finish:'責了',
    noChangeFinish:'校了',
  }
  getHistoryTypeName = type => {
    if (!this.historyTypeNames.hasOwnProperty(type)) return type;
    return this.historyTypeNames[type];
  }

  
  onClickAlertCloseButton = () => {
    this.setState({ showAlert: null });
  }

  onClickOpenAlbumSupport = () => {
    let m = window.location.href.match(/\/([^/]+)$/);
    window.location.href = window.location.origin + '?code=' + m[1].replace(/^(\d{9}).*$/, '$1');
  }

  /***************************/
  /*
  /*        画面表示
  /*
  /***************************/
  render() {
    if (this.state.loading) {
      return <Loader active={true}></Loader>;
    }

    let ori = this.state.albumData.oris.find(o=>{
      return o.oriuq === this.state.selectedOriuq;
    });

    let buttonDisabled = ['start','retake','finish','noChangeFinish','old'].indexOf(this.state.prStatus)>=0;

    return  (
      <LoadingOverlay className="Proofread-Editor-Loader" active={this.state.loadingOverlay} spinner>
        <div className="Proofread">
          <div className="Proofread-Header">
            <button className="Proofread-OpenAlbumSupport" onClick={this.onClickOpenAlbumSupport}>
              アルバム<br/>サポート<br/><span>戻る</span>
            </button>
            <div className="Proofread-Logo"></div>
            <div className="Proofread-Title">
              <span className="Proofread-AlbumName">{this.state.hinmei}</span>
              <span className="Proofread-PageName">{ori?ori.pageName:''}</span>
            </div>

            <span className="Proofread-Header-right">
              <div className="Proofread-Header-Tools" onClick={this.onClickTools}>
                <button className={"toolBtn" + (this.state.selectedTool==='default'?' selected':'')} data-tool-name="default" title="選択（調整・削除）" data-title="選択"
                  disabled={buttonDisabled}><FontAwesomeIcon icon={faArrowPointer}></FontAwesomeIcon></button>
                {/*<button className={"toolBtn" + (this.state.selectedTool==='remove'?' selected':'')} data-tool-name="remove" title="指示取り消し"
                  disabled={buttonDisabled}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></button>*/}
                <button className={"toolBtn" + (this.state.selectedTool==='pan'?' selected':'')} data-tool-name="pan" title="画面移動"
                  ><FontAwesomeIcon icon={faHand}></FontAwesomeIcon></button>
                <button className={"functionBtn" + (this.state.selectedTool==='zoomPlus'?' selected':'')} data-tool-name="zoomPlus" title="拡大"
                  ><FontAwesomeIcon icon={faSearchPlus}></FontAwesomeIcon></button>
                <button className={"functionBtn" + (this.state.selectedTool==='zoomMinus'?' selected':'')} data-tool-name="zoomMinus" title="縮小"
                  ><FontAwesomeIcon icon={faSearchMinus}></FontAwesomeIcon></button>
                <button className="functionBtn" data-tool-name="allView" title="全体表示"><FontAwesomeIcon icon={faExpand}></FontAwesomeIcon></button>
                <button className={"functionBtn"+(this.state.hasPrev?'':' grayout')} data-tool-name="undo" title="戻る"
                  disabled={buttonDisabled}><FontAwesomeIcon icon={faRotateLeft}></FontAwesomeIcon></button>
                <button className={"functionBtn"+(this.state.hasNext?'':' grayout')} data-tool-name="redo" title="進む"
                  disabled={buttonDisabled}><FontAwesomeIcon icon={faRotateRight}></FontAwesomeIcon></button>
                <button className="functionBtn" data-tool-name="directionView" title="指示のみ表示"><FontAwesomeIcon icon={faGlasses}></FontAwesomeIcon></button>
                <button className="functionBtn" data-tool-name="downloadPreview" title="プレビュー保存"><FontAwesomeIcon icon={faDownload}></FontAwesomeIcon></button>
              </div>
              <span className="Proofread-Header-saveButtons">
              {
                buttonDisabled
                ? null
                : <button className="Proofread-Header-SaveButton" onClick={this.onClickSaveButton}><FontAwesomeIcon icon={faSave}></FontAwesomeIcon>保存</button>
              }
              {
                (()=>{
                  if (this.state.prStatus === 'old') {
                    return null;
                  }
                  switch (this.state.prStatus) {
                    case 'start': return <button className="Proofread-Header-FinishButton schoolStart">学校確認中</button>;
                    case 'retake': return <button className="Proofread-Header-FinishButton retake" onClick={this.onClickFinishBtns}>再校正依頼中</button>;
                    case 'finish': return <button className="Proofread-Header-FinishButton finish">責了</button>;
                    case 'noChangeFinish': return <button className="Proofread-Header-FinishButton finish noChangeFinish">校了</button>;
                    default: return <button className="Proofread-Header-FinishButton finishBtn" onClick={this.onClickFinishBtns}>確認完了</button>;
                  }
                })()
              }
              </span>
              <div className="Proofread-Header-Tools" onClick={this.onClickTools}>
                <button className="functionBtn" data-tool-name="showManual" title="操作マニュアル"><FontAwesomeIcon icon={faFilePdf}></FontAwesomeIcon></button>
              </div>
            </span>
          </div>

          <div className="Proofread-Main">
            <div className="Proofread-Sidebar">
              <div className="Proofread-Sidebar-body">
                <input className="Proofread-Sidebar-tab" id="Proofread-Sidebar-tab-directions" type="radio" name="Proofread-Sidebar-tab" defaultChecked/>
                <label htmlFor="Proofread-Sidebar-tab-directions">指示一覧</label>
                <input className="Proofread-Sidebar-tab" id="Proofread-Sidebar-tab-histories" type="radio" name="Proofread-Sidebar-tab"/>
                <label htmlFor="Proofread-Sidebar-tab-histories">校正履歴</label>
                <div className="Proofread-Sidebar-content Proofread-Directions-items">
                  <div className="Proofread-Sidebar-contentWrap" onClick={this.onClickDirections}>{
                    this.PRCanvas ? ( this.PRCanvas.getDirections().map(this.renderDirection) ) : null
                  }</div>
                </div>
                <div className="Proofread-Sidebar-content Proofread-Histories-items">
                  <div className="Proofread-Sidebar-contentWrap" onClick={this.onClickHistories}>{
                    this.state.histories ? this.state.histories.map(this.renderHistory) :null
                  }</div>
                </div>
              </div>
            </div>
            <div className="Proofread-Editor">
              <div className="Proofread-Editor-Tools">
                <div className="Proofread-Editor-ToolButtons" onClick={this.onClickTools}>
                  <div className="Proofread-Editor-ToolButtonsLine">
                    <div className="Proofread-Editor-ToolButtonsLine-Title">指示</div>
                    <button className="functionBtn" data-tool-name="upload" title="差替写真UP"><FontAwesomeIcon icon={faCamera}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-changePlace'?' selected':'')} data-tool-name="draw-changePlace" title="場所入替"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faArrowsLeftRight}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-movePlace'?' selected':'')} data-tool-name="draw-movePlace" title="場所移動"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faArrowRightLong}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-changePhoto'?' selected':'')} data-tool-name="draw-changePhoto" title="写真差替"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faImage}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-addPhoto'?' selected':'')} data-tool-name="draw-addPhoto" title="写真追加"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faSquarePlus}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-trimming'?' selected':'')} data-tool-name="draw-trimming" title="トリミング"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faCropSimple}></FontAwesomeIcon></button>
                      <button className={"toolBtn" + (this.state.selectedTool==='draw-changeChar'?' selected':'')} data-tool-name="draw-changeChar" title="文字変更"
                        disabled={buttonDisabled}><FontAwesomeIcon icon={faA}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-comment'?' selected':'')} data-tool-name="draw-comment" title="コメント"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon></button>
                    <button className={"toolBtn" + (this.state.selectedTool==='draw-delete'?' selected':'')} data-tool-name="draw-delete" title="トル"
                      disabled={buttonDisabled}><CrossRectSVG/></button>
                    {/*<button className={"toolBtn" + (this.state.selectedTool==='draw-keep'?' selected':'')} data-tool-name="draw-keep" title="修正ナシ"
                      disabled={buttonDisabled}><FontAwesomeIcon icon={faCircleCheck}></FontAwesomeIcon></button>*/}
                  </div>
                </div>

              </div>
              <div className="Proofread-Editor-CanvasWrap" style={{width: this.state.canvasWidth+'px'}}>
                <ProofreadCanvas
                  ref={ref=>{this.PRCanvas=ref;}}
                  oriuq={this.state.selectedOriuq}
                  preview={this.state.preview}
                  previewFilename={this.state.previewFilename}
                  openedStatus={this.state.openedStatus}
                  savedFabricData={this.state.savedFabricData}
                  tool={this.state.selectedTool}
                  event={this.onEventFromCanvas} 
                  changeStarted={this.state.changeStarted}
                  moveStarted={this.state.moveStarted}
                  canvasWidth={this.state.canvasWidth}
                  canvasHeight={this.state.canvasHeight}
                  />
              </div>

            </div>
          </div>
          { this.state.changeStarted ? this.renderChangeStarted() : null }
          { this.state.moveStarted ? this.renderMoveStarted() : null }
          { this.state.showUploadDialog ? this.renderShwoUploadDialog() : null }
          { this.state.showSaveDialog ? this.renderSaveDialog() : null }
          { this.state.showSaveAlert ? this.renderShowSaveAlert() : null }
          { this.state.showCustomerFinish ? this.renderCustomerFinishAlert() : null }
          { this.state.showToSchool ? this.renderToSchoolAlert() : null }
          { this.state.showSchoolFinish ? this.renderSchoolFinishAlert() : null }
          { this.state.showLogout ? this.renderLogoutAlert() : null }
          { this.state.showAlert ? this.renderAlert() : null }
        </div>
        <PDFDialog ref={ref=>{this.pdfDlg=ref;}} />
      </LoadingOverlay>
    );
  }

  renderHistory = (history, idx) => {

    let title = (()=>{
      if (history.filename) {
        if (history.current) return '編集に戻ります。';
        else return '過去データを閲覧します。';
      }
      return '';
    })();

    let classes = ['Proofread-History'];
    if (history.filename === this.state.history || (!this.state.history && history.current)) classes.push('Proofread-History-Selected');
    let base64url = ['save','retake', 'finish','noChangeFinish'].indexOf(history.type)>=0 ? "data:image/jpeg;base64,"+history.thumbnail : '';
    
    return (
      <div className={classes.join(' ')} key={idx} data-direction={history.filename} data-current={history.current?'true':'false'}
        title={title} data-type={history.type}
        >
        <div className="Proofread-History-Thumbnail">{
          <img src={base64url} alt={title}/>
        }</div>
        <div className="Proofread-History-Timestamp">{history.timestamp}</div>
      </div>
    );
  }

  renderDirection = (o) => {
    let classes = (()=>{
      let c = ["Proofread-Direction"];
      if (this.state.selectedDirection && this.state.selectedDirection!==o.createdTimestamp.toString()) c.push('notSelected');
      if (this.state.selectedTarget === o.createdTimestamp) c.push('selected');
      return c.join(' ');
    })();
    let editable = (()=>{
      if (['finish', 'retake', 'noChangeFinish', 'old'].indexOf(this.state.prStatus) >= 0) return false;
      if (this.state.prStatus === 'start') return false;
      return true;
    })();
    return (
      <div key={o.createdTimestamp} 
        className={classes}
        data-creator={o.creator}
        data-timestamp={o.createdTimestamp}>
        <div className="Proofread-Direction-Header">
          <div className="Proofread-Direction-Num">{o.num}</div>
          <div className="Proofread-Direction-Type">{this.getDirectionTypeName(o.directionType)}</div>
          {/*<FontAwesomeIcon className="Proofread-Direction-CreatorIcon" icon={o.creator==='school'?faSchool:faCamera}></FontAwesomeIcon>*/}
        </div>
        <div className="Proofread-Direction-Row">
          <label className="Proofread-Direction-Label">指示詳細</label>
          <div className="Proofread-Direction-Value" data-key="title" onClick={editable?this.onClickDirectionInput:null}>
            {
              this.state.directionEditTarget && this.state.directionEditTarget.ts === o.createdTimestamp.toString() && this.state.directionEditTarget.key === 'title'
              ? <textarea className="Proofread-Direction-ValueInput" onBlur={this.onBlurDirectionInput} autoFocus={true} defaultValue={o.title}></textarea>
              : <div className="Proofread-Direction-ValueText">{o.title}</div>
            }
          </div>
        </div>
        {
          o.directionType.match(/Photo$/) && o.photo
          ? (
            <div className="Proofread-Direction-Row">
              <label className="Proofread-Direction-Label">{o.directionType==='changePhoto'?'差替':'追加'}ファイル名</label>
              <div className="Proofread-Direction-Value">{o.photo.replace(/_[^_/]+(\.[^.]+)$/, '$1')}</div>
            </div>
          )
          : null
        }
      </div>
    )
  }
  renderChangeStarted = () => {
    return (
      <div className="Proofread-Editor-ChangeStartedDialog">
        入れ替え先の枠を描画してください。
        <button onClick={this.onClickChangeCancelBtn}>キャンセル</button>
      </div>
    )
  }
  renderMoveStarted = () => {
    return (
      <div className="Proofread-Editor-ChangeStartedDialog">
        移動先を描画してください。
        <button onClick={this.onClickMoveCancelBtn}>キャンセル</button>
      </div>
    )
  }
  renderShwoUploadDialog = () => {
    let usedPhotos = this.state.savedFabricData ? this.state.savedFabricData.objects.filter(o=>o.directionType && o.directionType.match(/Photo$/) && o.photo).map(o=>o.photo) : [];
    usedPhotos = usedPhotos.concat(this.PRCanvas.createSaveData().objects.filter(o=>o.directionType && o.directionType.match(/Photo$/) && o.photo && usedPhotos.indexOf(o.photo) < 0).map(o=>o.photo));

    return (
      <div className="Proofread-Editor-UploadDialog dialog">
        <div className="Proofread-Editor-UploadDialog-Window dialog-window">
          <LoadingOverlay active={!!this.state.loadingUploadDialog} spinner text={this.state.loadingUploadDialog}
            className='Proofread-Editor-UploadDialog-LoadingOverlay'>
          
            <div className="Proofread-Editor-UploadDialog-Header">
              <button className="Proofread-Editor-UploadDialog-CloseBtn" onClick={this.onClickUploadDialogCloseBtn}><FontAwesomeIcon icon={faTimes}></FontAwesomeIcon></button>
              <button className="Proofread-Editor-UploadDialog-UploadBtn" onClick={this.onClickUploadDialogUploadBtn}><FontAwesomeIcon icon={faUpload}></FontAwesomeIcon>画像のアップロード</button>
              <button className={"Proofread-Editor-UploadDialog-DeleteBtn" + (this.state.selectedPhotos.length === 0 ? ' disabled' : '')} onClick={this.onClickUploadDialogDeleteBtn}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>選択画像の削除</button>
              <div className="Proofread-Editor-UploadDialog-Counter">
                <div className="Proofread-Editor-UploadDialog-CounterValue">
                  <div className="Proofread-Editor-UploadDialog-CounterCountValue">{this.state.uploadedPhotos.length}</div>/<div className="Proofread-Editor-UploadDialog-CounterLimitValue">{config.maxUploadPhotoCount}</div>
                </div>
                <div className="Proofread-Editor-UploadDialog-CounterTitle">アップロード点数制限</div>
              </div>
            </div>
                
            <div className="Proofread-Editor-UploadDialog-Photos" onClick={this.onClickUploadDialogPhotos}>
              {
                this.state.uploadedPhotos.map( (p, idx)=>{
                  let name = p.name.replace(/_[^_/]+(\.[^.]+)$/, '$1');
                  let classes = ["Proofread-Editor-UploadDialog-Photo"];
                  if (this.state.selectedPhotos.indexOf(p.name) >= 0) classes.push('selected');
                  if (usedPhotos.indexOf(p.name) >= 0) classes.push('used');
                  return (<div key={idx} className={classes.join(' ')} title={name} data-unique={p.name}>
                    <img src={"data:image/jpeg;base64,"+p.thumbnail} alt={name}/>
                    <div className="Proofread-Editor-UploadDialog-PhotoName">{name}</div>
                  </div>)
                })
              }
            </div>
          </LoadingOverlay>
        </div>
      </div>
    )
  }
  renderSaveDialog = () => {
    return (
      <div className="Proofread-Editor-SaveDialog dialog">
        <div className="Proofread-Editor-SaveDialog-Window dialog-window">
          <div className="Proofread-Editor-SaveDialog-Message dialog-message">保存してよろしいですか？</div>
          <div className="Proofread-Editor-SaveDialog-Buttons dialog-buttons" onClick={this.onClickSaveDialogButtons}>
            <button name="cancelBtn" className="dialog-button">キャンセル</button>
            <button name="okBtn" className="dialog-button">保存</button>
          </div>
        </div>
      </div>
    )
  }
  renderShowSaveAlert = () => {
    return (
      <div className="Proofread-Editor-SaveDialog dialog">
        <div className="Proofread-Editor-SaveDialog-Window dialog-window">
          <div className="Proofread-Editor-SaveDialog-Message dialog-message">保存されていません。<br/>保存していない変更は失われますが、よろしいですか？</div>
          <div className="Proofread-Editor-SaveDialog-Buttons dialog-buttons" onClick={this.onClickSaveAlertButtons}>
            <button name="cancelBtn" className="dialog-button">キャンセル</button>
            <button name="okBtn" className="dialog-button">保存しない</button>
          </div>
        </div>
      </div>
    )
  }
  renderCustomerFinishAlert = () => {
    let saveData = this.PRCanvas.createSaveData();
    let changed = saveData.objects.filter(o=>o.type!=='PRBase').length > 0;
    return (
      <div className="Proofread-Editor-CustomerFinishAlert dialog" >
        <div className="Proofread-Editor-CustomerFinishAlert-Window dialog-window">
          <form className="Proofread-Editor-CustomerFinishAlert-Message dialog-message" ref={ref=>{this.customerFinishType=ref;}}>
            <div><label><input type="radio" name="customerFinish" value="noChangeFinish" defaultChecked/>変更なし 印刷進行 OK</label></div>
            <div data-disabled={changed?'false':'true'}><label><input type="radio" name="customerFinish" value="finish" disabled={!changed}/>修正後 印刷進行 OK</label></div>
            <div data-disabled={changed?'false':'true'}><label><input type="radio" name="customerFinish" value="retake" disabled={!changed}/>再校正が必要</label></div>
            <div className="receiveMailWrap">
              <label><input type="checkbox" name="receiveMail" defaultChecked/>完了メールを受け取る</label>
            </div>
          </form>
          <div className="Proofread-Editor-CustomerFinishAlert-Buttons dialog-buttons" onClick={this.onClickCustomerFinishAlertButtons}>
            <button name="cancelBtn" className="dialog-button">キャンセル</button>
            <button name="okBtn" className="dialog-button">確認完了</button>
          </div>
        </div>
      </div>
    )
  }
  renderToSchoolAlert = () => {
    return (
      <div className="Proofread-Editor-ToSchoolAlert dialog">
        <div className="Proofread-Editor-ToSchoolAlert-Window dialog-window">
          <div className="Proofread-Editor-ToSchoolAlert-Message dialog-message">
            学校へ確認依頼を開始しますか？
          </div>
          <div className="Proofread-Editor-ToSchoolAlert-Buttons dialog-buttons" onClick={this.onClickToSchoolAlertButtons}>
            <button name="cancelBtn" className="dialog-button">キャンセル</button>
            <button name="okBtn" className="dialog-button">学校確認開始</button>
          </div>
        </div>
      </div>
    );
  }
  renderSchoolFinishAlert = () => {
    return (
      <div className="Proofread-Editor-CustomerFinishAlert dialog" >
        <div className="Proofread-Editor-CustomerFinishAlert-Window dialog-window">
          <div className="Proofread-Editor-CustomerFinishAlert-Message dialog-message">
            校正確認を完了してよろしいですか？
          </div>
          <div className="Proofread-Editor-CustomerFinishAlert-Buttons dialog-buttons" onClick={this.onClickSchoolFinishAlertButtons}>
            <button name="cancelBtn" className="dialog-button">キャンセル</button>
            <button name="okBtn" className="dialog-button">確認完了</button>
          </div>
        </div>
      </div>
    )
  }
  renderLogoutAlert = () => {
    return (
      <div className="Proofread-Editor-LogoutAlert dialog">
        <div className="Proofread-Editor-LogoutAlert-Window dialog-window">
          <div className="Proofread-Editor-LogoutAlert-Message dialog-message">
            ログアウトしますか？
          </div>
          <div className="Proofread-Editor-LogoutAlert-Buttons dialog-buttons" onClick={this.onClickLogoutAlertButtons}>
            <button name="cancelBtn" className="dialog-button">キャンセル</button>
            <button name="okBtn" className="dialog-button">ログアウト</button>
          </div>
        </div>
      </div>
    );
  }
  renderAlert = () => {
    console.log(this.state.showAlert)
    return (
      <div className="Proofread-Editor-Alert dialog">
        <div className="Proofread-Editor-Alert-Window dialog-window">
          <div className="Proofread-Editor-Alert-Message dialog-message">
            {this.state.showAlert.message}
          </div>
          {this.state.showAlert.closeButton || this.state.showAlert.okButton
            ? (
            <div className="Proofread-Editor-Alert-Message dialog-buttons">
              { this.state.showAlert.closeButton ? <button className="Proofread-Editor-Alert-CancelButton" onClick={this.onClickAlertCloseButton}>{this.state.showAlert.closeButtonTitle||'閉じる'}</button> : null }
              { this.state.showAlert.okButton ? <button className="Proofread-Editor-Alert-OKButton" onClick={this.state.showAlert.okButton}>{this.state.showAlert.okButtonTitle||'OK'}</button> : null }
            </div>
            )
            : null
          }
        </div>
      </div>
    );
  }
}
export default Proofread;